import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { InputField, SimpleSelectField } from '@unite-us/app-components';
import AddressFieldConditionalDisplay from './AddressFieldConditionalDisplay';
import { DISPLAY_CITY_STATE, DISPLAY_POSTAL_CODE } from '../constants';

const getFieldError = (meta) => (meta.touched && meta.error ? meta.error : undefined);

const required = (value) => (value ? undefined : 'Required');

const getEventValue = (e) => (e?.target ? e.target.value : e);

function AddressStateZipFields({
  addressId,
  displayFieldSet,
  fieldPrefix,
  inline,
  inputStyle,
  labelStyle,
  onFieldChange,
  usStates,
}) {
  return (
    <div className="row">
      <AddressFieldConditionalDisplay selectedFieldSet={displayFieldSet} validDisplayTypes={DISPLAY_CITY_STATE}>
        <div className="col-xs-12 col-sm-6">
          <Field name={`${fieldPrefix}.state`} validate={required}>
            {({ input, meta }) => (
              <SimpleSelectField
                className="address-field-state"
                id={`${addressId}-state`}
                label="State"
                value={input.value}
                onChange={(value) => onFieldChange('state', value, input.onChange)}
                onBlur={input.onBlur}
                options={usStates}
                optionSettings={{ labelKey: 'display_name', valueKey: 'value' }}
                placeholder="Select state"
                error={getFieldError(meta)}
                required
              />
            )}
          </Field>
        </div>
      </AddressFieldConditionalDisplay>

      <AddressFieldConditionalDisplay selectedFieldSet={displayFieldSet} validDisplayTypes={DISPLAY_POSTAL_CODE}>
        <div className="col-xs-12 col-sm-6">
          <Field name={`${fieldPrefix}.postal_code`} validate={required}>
            {({ input, meta }) => (
              <InputField
                id={`${addressId}-postal-code`}
                inline={inline}
                inputStyle={inputStyle}
                label="Zip Code"
                labelStyle={labelStyle}
                maxLength="5"
                placeholder="Zip Code"
                value={input.value}
                onChange={(e) => onFieldChange('postal_code', getEventValue(e), input.onChange)}
                onBlur={input.onBlur}
                error={getFieldError(meta)}
                required
              />
            )}
          </Field>
        </div>
      </AddressFieldConditionalDisplay>
    </div>
  );
}

AddressStateZipFields.propTypes = {
  addressId: PropTypes.string.isRequired,
  displayFieldSet: PropTypes.string.isRequired,
  fieldPrefix: PropTypes.string.isRequired,
  inline: PropTypes.bool.isRequired,
  inputStyle: PropTypes.object.isRequired,
  labelStyle: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  usStates: PropTypes.array.isRequired,
};

export default AddressStateZipFields;
